require('./bootstrap');

let adminScripts = require('./admin');
let clientScripts = require('./client');
let guideScripts = require('./guide');
let tripRegistration = require('./tripRegistration');
let typeaheadListeners = require('./typeahead');
let modalListeners = require('./modal');
let dynamicScripts = require('./dynamic');
let depResScripts = require('./departureReservation')

let http = require('./http');
let Cookie = require("js-cookie");


import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import 'jquery-ui/ui/widgets/sortable';

datepickerFactory($);

$(document).ready(function ($) {

    let lastScrollTop = Cookie.get('last-scroll-top');
    if (lastScrollTop) {
        $(window).scrollTop(lastScrollTop);
        Cookie.remove('last-scroll-top');
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    adminScripts.initAdminScripts();
    clientScripts.initClientScripts();
    guideScripts.initGuideScripts();
    tripRegistration.initTripRegistrationListeners();
    typeaheadListeners.initTypeAHeadListeners();
    modalListeners.initModalListeners();
    dynamicScripts.initDynamicScripts();
    depResScripts.departureReservationScripts()

    //Added jQuery datepicker for public facing sites.
    $('.datePicker').each(function () {
        $(this).datepicker({
            dateFormat: 'yy-mm-dd',
            changeMonth: true,
            changeYear: true,
            yearRange: '1918:2030'
        });
    });

    $('.trip-gear-input').on('click', function() {
        var $elem = $(this);
        updateTripGear($elem.data('trip-id'), $elem.data('gear-id'), $elem.is(':checked'));
    });

    var updateTripGear = function (trip_id, gear_id, rel) {
        var data = {
            'trip_id': trip_id,
            'rel': rel
        };
        $.post('/gear/' + gear_id + '/updateTripGear', data, function (result) {
            if (result.status === 'error') {
                alert(result.message);
                if (icon.hasClass('red')) {
                    icon.removeClass('red');
                    icon.addClass('light-green');
                } else {
                    icon.removeClass('light-green');
                    icon.addClass('red');
                }
            } else {
                // Nothing
            }
        });
    }


    $('.handle-registration').on('click', function () {
        var elem = $(this);
        toggleSpinner(elem);
        var data = {};
        data.action = $(this).data('action');
        data.registration_id = $(this).data('registration-id');
        data.client_id = $(this).data('client-id');
        $.post('/registrations/' + data.action, data, function (result) {
            toggleSpinner(elem, true);
            if (result.status == 'success') {
                $('#registration-import-' + result.input.registration_id + ' td:last-of-type').html(result.message);
            } else {
                alert(result.message);
            }
        });
    });

    var rental_items_group = [];
    $('.rental-row').on('change', function () {
        var rental_item_id = $(this).data('rental-item-id');
        var rental_id = $(this).data('rental-id');

        if (rental_items_group[rental_id].indexOf(rental_item_id) > -1) {
            rental_items_group[rental_id].splice(rental_items_group[rental_id].indexOf(rental_item_id), 1);
        } else {
            rental_items_group[rental_id].push(rental_item_id);
        }
        $('#rental_group_count').html(rental_items_group.length);
    });

    $('.import-rental-order').on('click', function () {
        var elem = $(this);
        toggleSpinner(elem);
        var data = {};
        data.rental_id = $(this).data('rental-id');
        data.client_id = $(this).data('client-id');
        $.post('/rentals', data, function (result) {
            toggleSpinner(elem, true);
            $('#rental-import-' + result.data.rental_id + '-actions').html('<h5>Imported!</h5>');
        });
    });

    $('.trip-requirement-toggle').on('click', function () {
        var elem = $(this);
        var icon = $(this).find('.fa');
        var data = {};
        data.trip_requirement_id = elem.data('trip-requirement-id');
        data.departure_requirement_id = elem.data('departure-requirement-id');
        data.client_id = elem.data('client-id');

        // Assume the best!
        if (icon.hasClass('red')) {
            icon.removeClass('red');
            icon.addClass('light-green');
        } else {
            icon.removeClass('light-green');
            icon.addClass('red');
        }

        $.post('/departureReservation/' + elem.data('uuid') + '/requirement', data, function (result) {
            if (result.status === 'error') {
                alert(result.message);
                if (icon.hasClass('red')) {
                    icon.removeClass('red');
                    icon.addClass('light-green');
                } else {
                    icon.removeClass('light-green');
                    icon.addClass('red');
                }
            } else {
                // Nothing
            }
        });
    });

    $('.delete-button').on('click', function () {
        if (confirm('Are you sure you want to delete this?')) {
            $(this).html('<i class="fa fa-cog fa-spin"></i>');
            $.ajax({
                url: $(this).data('href'),
                type: 'DELETE',
                success: function (result) {
                    if (result.hasOwnProperty('reload')) {
                        Cookie.set('last-scroll-top', $(window).scrollTop());
                        location.reload();
                    } else if (result.hasOwnProperty('callback')) {
                        Cookie.set('last-scroll-top', $(window).scrollTop());
                        window.location.href = result.callback;
                    } else {
                        Cookie.set('last-scroll-top', $(window).scrollTop());
                        window.location = window.location;
                        // location.reload();
                    }
                }
            });
        }
    });

    $('.restore-button').on('click', function () {
        if (confirm('Are you sure you want to restore this?')) {
            $(this).html('<i class="fa fa-cog fa-spin"></i>');
            $.ajax({
                url: $(this).data('href'),
                type: 'POST',
                success: function (result) {
                    if (result.callback) {
                        window.location = result.callback;
                    } else {
                        window.location = window.location;
                    }
                }
            });
        }
    });

    $('.departure_reservation_trip_option_toggle').on('change', function() {
        var elem = $(this);
        var uuid = $('#departure_reservation_uuid').val();
        var data = {
            trip_option_id: elem.data('id'),
            trip_option_state: elem.is(':checked') ? 1 : 0,
        }
        $.post('/departureReservation/' + uuid + '/toggleTripOption', data, function (result) {
            console.log(result);
            if(result.status == 'success') {
                // No news is good news
            } else {
                console.log(result.message);
                alert(result.message);
            }
        });
    });

    $('.send-survey-invite-email').on('click', function (e) {
        var elem = $(this);
        toggleSpinner(elem);
        var sid = elem.data('sid');
        var did = elem.data('did');
        var cid = elem.data('cid');
        var uri = '?sid=' + sid + '&cid=' + cid + '&did=' + did;

        $.post('/survey/invite' + uri, function (data) {
            console.log(data);
            if (data.status == 'success' || data.status == 200) {
                toggleSpinner(elem);
                elem.replaceWith(`<p>${data.message}</p>`);
            } else {
                toggleSpinner(elem);
                console.log(data.message);
            }
        });
    });

    $('#length_select').change(function(elem) {
        var days = $(this).val();
        window.location = window.location.href.split('?')[0] + '?days=' + days;
    });

    $('#completed_length_select').change(function () {
        var days = $(this).val();
        window.location = window.location.href.split('?')[0] + '?days=' + days;
    })

    $('#rental_length_select').change(function () {
        var days = $(this).val();
        window.location = window.location.href.split('?')[0] + '?days=' + days;
    });

    $('.show-hide_app').click(function () {
        $(this).next('.report_client_app').slideToggle();
    });


    $('#trip-option').on('change', function (e) {

        $('#departure-block').children().remove();

        let loading = '<div class="text-center mx-auto m-5"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>';

        $('#departure-block').html(loading);

        let registration_id = $(this).data('registration')

        if ($(this).val()) {
            $.ajax({
                url: '/registrations/schedule/departures/get?trip=' + $(this).val()
            })
                .done(function (response) {
                    if (response.departures === undefined || response.departures.length == 0) {
                        $('#departure-block').html("<h6 class='text-center mx-auto m-3'>No Upcoming Departures For This Trip</h6>");
                    } else {
                        $('#departure-block').children().remove();
                        $.each(response.departures, function () {
                            let id = $(this)[0].id;
                            let date = new Date($(this)[0].departure_date).toDateString();
                            $('#departure-block').append($("<button>", {
                                type: 'button',
                                class: 'btn-block btn-sm btn-outline-secondary process-registration',
                                id: registration_id,
                                'data-departure-id': id,
                                'data-reload': false
                            }).html($(this)[0].description + " Departs: " + date));
                        });
                    }

                })
                .fail(function (error) {
                    console.log(error);
                });
        }
    });

    $(document).on('click', '.process-registration', function () {

        $('.process-registration').attr('disabled', 'disabled');

        var $activeBtn = $(this);
        var regId = $activeBtn.attr('id');
        var depId = $activeBtn.data('departure-id');
        var depDate = $activeBtn.data('departure-date');
        var activeBtnHtml = $activeBtn.html();

        let reload = $activeBtn.data('reload');

        $activeBtn.html('<i class="fa fa-cog fa-spin"></i> Creating Reservation...');

        let data = {
            'departure_id': depId,
            'departure_date': depDate,
            'reload': reload
        };

        $.post('/registrations/' + regId + '/process', data, function (result) {
            if (result.reload == 'true') {
                window.open(result.redirect, '_blank');
                location.reload(true);
            } else {
                location.replace(result.redirect)
            }
        });
    });

    $(document).on('click', '.delete-record', function () {
        confirm('Are you sure you want to delete this?');
        $(this).html('<i class="fa fa-cog fa-spin red"></i>');

        let data = new FormData();

        if (!$.isEmptyObject($(this).data())) {
            let dataAttr = $(this).data();
            $.each(dataAttr, function (key, value) {
                data.set(key, value);
            });
        }

        http.sendAjax($(this).data('href'), 'POST', data, http.success, http.errors);
    });

    $('#update-terms-release').validate({
        errorElement: 'div',
        validClass: "div",
        invalidHandler: function (event, validator) {
            let errors = validator.numberOfInvalids();
            if (errors) {
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
                $('#errorContainer').append('<div class="alert alert-danger alert-dismissible fade show" role="alert">Please fill all required fields.<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div >');
            }

        }
    });

    $(document).on('submit', '#update-terms-release', function (el) {
        el.preventDefault();

        $('#errorContainer').children().remove();

        if ($(this).valid()) {
            if (confirm("Are you sure you want to submit this form?")) {

                let form = $(this);
                let url = form[0].action;
                let data = form.serialize();
                let button = form.find('#submitButton');

                button.prop('disabled', true);
                button.html('<i class="fa fa-cog fa-spin spinner"></i>');
                form.attr('disabled', 'true');

                function success(response, status, xhr) {
                    if (response.errors) {
                        for (var key in response.errors) {
                            response.errors[key].forEach(function (message) {
                                $('#errorContainer').append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div >');
                            });
                        }

                        $('html, body').animate({
                            scrollTop: 0
                        }, 500);
                    }


                    if (response.redirect) {
                        window.location.replace(response.redirect);
                    } else {
                        console.log('else');
                        console.log(button);
                        button.html('Submit Forms');
                        button.prop('disabled', false);
                        form.removeProp('disabled');
                    }
                }

                $.post(url, data, success, 'json');
            }
        }
    });

});



function toggleSpinner($elem, hide) {
    $elem.find('.spinner').remove();
    if (!hide) {
        var spinnerHtml = '<i class="fa fa-cog fa-spin spinner"></i>';
        if ($elem.find('i')) {
            $elem.find('i').replaceWith(spinnerHtml);
        } else {
            $(spinnerHtml).appendTo($elem);
        }
    }
}
